import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// Alternative for Vercel deployment issues: import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Vercel Speed Insights and Analytics removed
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Calculator from './pages/Calculator';
import Contact from './pages/Contact';
import Landing from './pages/Landing';
import ConstructionSafety from './pages/ConstructionSafety';
import SportsSafety from './pages/SportsSafety';
import IndustrialSafety from './pages/IndustrialSafety';
import PigeonNets from './pages/PigeonNets';
import ChildSafetyNet from './pages/ChildSafetyNet';
import InvisibleGrill from './pages/InvisibleGrill';
import InvisibleGrillBalconies from './pages/InvisibleGrillBalconies';
import InvisibleGrillWindows from './pages/InvisibleGrillWindows';
import InvisibleGrillApartments from './pages/InvisibleGrillApartments';
import PullDryClothHangers from './pages/PullDryClothHangers';
import CeilingClothHangers from './pages/CeilingClothHangers';
import PullDryClothHangersBalconies from './pages/PullDryClothHangersBalconies';
import CarParkingNet from './pages/CarParkingNet';
import SwimmingPoolNet from './pages/SwimmingPoolNet';
import CoconutNet from './pages/CoconutNet';
import ConstructionNet from './pages/ConstructionNet';
import ShadeNet from './pages/ShadeNet';
  import BalconySafetyNets from './pages/BalconySafetyNets';
import SafetyNet from './pages/SafetyNet';

import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import Sitemap from './pages/Sitemap';
import Article from './pages/Article';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FloatingButtons from './components/FloatingButtons';
import ScrollToTop from './components/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <GoogleAnalytics />
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Services />} />
              <Route path="/services" element={<Navigate to="/products" replace />} />
            <Route path="/construction-safety" element={<ConstructionSafety />} />
            <Route path="/sports-safety" element={<SportsSafety />} />
            <Route path="/industrial-safety" element={<IndustrialSafety />} />
            <Route path="/pigeon-nets" element={<PigeonNets />} />
            <Route path="/child-safety-net" element={<ChildSafetyNet />} />
            <Route path="/invisible-grill" element={<InvisibleGrill />} />
            <Route path="/invisible-grill-balconies" element={<InvisibleGrillBalconies />} />
            <Route path="/invisible-grill-windows" element={<InvisibleGrillWindows />} />
            <Route path="/invisible-grill-apartments" element={<InvisibleGrillApartments />} />
            <Route path="/pull-dry-cloth-hangers" element={<PullDryClothHangers />} />
            <Route path="/ceiling-cloth-hangers" element={<CeilingClothHangers />} />
            <Route path="/pull-dry-cloth-hangers-balconies" element={<PullDryClothHangersBalconies />} />
            <Route path="/car-parking-net" element={<CarParkingNet />} />
            <Route path="/swimming-pool-net" element={<SwimmingPoolNet />} />
            <Route path="/coconut-net" element={<CoconutNet />} />
            <Route path="/construction-net" element={<ConstructionNet />} />
            <Route path="/shade-net" element={<ShadeNet />} />
            <Route path="/balcony-safety-nets" element={<BalconySafetyNets />} />
            <Route path="/safety-net" element={<SafetyNet />} />
              <Route path="/about" element={<About />} />
              <Route path="/calculator" element={<Navigate to="/solar-calculator" replace />} />
              <Route path="/solar-calculator" element={<Calculator />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/landing" element={<Landing />} />

              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Article />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />

              {/* Catch all route for 404 errors - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <FloatingButtons />
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
